module.exports = __webpack_public_path__ + "static/media/icon-light-dark.c9ad7631.svg";